import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';

import { Button } from 'semantic-ui-react';

import * as templateLib from 'libs/templateLib';
import * as templateActions from 'modules/template';

import { LicenseEditModal } from 'components';

class CtLicenseRequest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: false,
      editModal: false
    };
  }

  mountEditModal = () => {
    const { editModal } = this.state;

    if (editModal) {
      // 열려진 경우로 닫는다.
      this.setState({ editModal: false });
    } else {
      // 닫혀진 경우로 연다.
      this.setState({ editModal: true });
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, editModal } = this.state;
    const { isAuth, actionMode, licenseInfo } = this.props;
    const { mountEditModal } = this;

    const licenseAction = {
      // renew: {
      //   color: 'green',
      //   content: defineMessages(formatMessage({ id: 'CtLicenseRequest_1', defaultMessage: '갱신 신청' }))
      // },
      // add: {
      //   color: 'blue',
      //   content: defineMessages(formatMessage({ id: 'CtLicenseRequest_2', defaultMessage: '추가 발급' }))
      // },
      default: {
        color: 'blue',
        content: defineMessages(formatMessage({ id: 'CtLicenseRequest_3', defaultMessage: '발급 신청' }))
      }
    };

    let className = '';
    if (actionMode === 'add') {
      className = 'bt-style-gleam license-button-brand';
    } else if (actionMode === 'default') {
      className = 'bt-style-gleam common-button-brand';
    } else if (actionMode === 'renew') {
      className = 'bt-style-gleam license-button-brand';
    }

    return (
      <div>
        {licenseAction[actionMode] && (
          <Button
            className={className}
            size="small"
            content={
              isAuth === 2
                ? defineMessages(formatMessage({ id: 'CtLicenseRequest_4', defaultMessage: '발 급' }))
                : licenseAction[actionMode].content
            }
            onClick={mountEditModal}
            // color={licenseAction[actionMode].color}
          />
        )}
        {editModal && (
          <LicenseEditModal
            actionMode={actionMode}
            licenseInfo={licenseInfo}
            isAuth={isAuth}
            mountEditModal={mountEditModal}
          />
        )}
      </div>
    );
  }
}

CtLicenseRequest.propTypes = {
  licenseInfo: PropTypes.object,
  actionMode: PropTypes.string
};
CtLicenseRequest.defaultProps = {
  licenseInfo: {},
  actionMode: 'default'
};

const mapStateToProps = state => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

export default connect(mapStateToProps)(injectIntl(CtLicenseRequest));



// WEBPACK FOOTER //
// ./src/script/containers/license/CtLicenseRequest.js